module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-lewis.302e0b8.png";